import keyBy from 'lodash/keyBy';
import mapValues from 'lodash/mapValues';

import { PrinterTypeEnum } from '@/modules/common';
import { PrinterType } from '@/modules/common/types';
import { GcrDetails } from '@/modules/gcrs/types';
import { Model } from '@/modules/models/types';

import { EventPrinter } from '../types';

export const getModelGcrFileDetails = ({
  modelId,
  models,
  gcrs,
  sizeId,
  printers,
  eventPrinters,
}: {
  sizeId: string;
  modelId: string;
  models: Model[];
  gcrs: GcrDetails[];
  printers: PrinterType[];
  eventPrinters: EventPrinter[];
}): {
  typeId?: string;
  emptyGcrFilePrinter: PrinterType | null;
  isShoe?: boolean;
} => {
  const formattedPrintersData = mapValues(keyBy(printers, 'id'));

  const activeModel = models.find((model) => model.id === modelId);

  if (!activeModel) {
    return {
      typeId: undefined,
      emptyGcrFilePrinter: null,
    };
  }

  if (activeModel.type?.isShoe) {
    return {
      typeId: activeModel.type.id,
      emptyGcrFilePrinter: null,
      isShoe: true,
    };
  }

  const filteredGcrFilePrinters = gcrs.flatMap((gcr) =>
    gcr.combinations
      .filter(
        ({ type, size }) =>
          type.id === activeModel.type.id && size.id === sizeId
      )
      .map((combination) => combination.printer)
  );
  const eventPrinterIds = filteredGcrFilePrinters.map((item) => item.id);
  const emptyGcrFilePrinter = eventPrinters.find(
    (printer) =>
      printer.type !== PrinterTypeEnum.API &&
      !eventPrinterIds.includes(printer.printerId)
  );

  return {
    typeId: activeModel.type?.id,
    emptyGcrFilePrinter: emptyGcrFilePrinter
      ? formattedPrintersData[emptyGcrFilePrinter?.printerId]
      : null,
  };
};
